import angular from 'angular';
import { NotificacoesIndexController } from './index/notificacoes.controller';
import { NotificacoesService } from './notificacoes.service';
import { NotificacoesListRouting } from './notificacoes.routes';


export const NotificacoesModule = angular.module('NotificacoesModule', ['ui.router.state', ])
    .controller('NotificacoesIndexController', NotificacoesIndexController)
    .service('NotificacoesService', NotificacoesService)
    .config(NotificacoesListRouting)
    .name;
